import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaArrowUp, FaArrowDown } from "react-icons/fa";
import DashboardLayout from "./DashboardLayout";
import { CustomerContext } from "../context/customerContext";
import {
  getSalesKpi,
  getNotBoughtProducts,
  getSalesByGroup,
  getProductGroups,
  getTopProducts
} from "../services/ReportService";

import PieChartComponent from "../components/PieChart";

const SalesInfo = () => {
  const navigate = useNavigate();
  const { customer } = useContext(CustomerContext);

  const [kpi, setKpi] = useState(null);
  const [groups, setGroups] = useState([]);
  const [notBought, setNotBought] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("all");
  const [topProducts, setTopProducts] = useState([]);

  // const mockTopProducts = [
  //   { productName: "ماست تازه کم چرب ۷۵۰ گرم هراز", totalValue: 985000000 },
  //   { productName: "شیر کم چرب ۱ لیتری هراز", totalValue: 870000000 },
  //   { productName: "ماست تازه پرچرب ۷۵۰ گرم هراز", totalValue: 760000000 },
  //   { productName: "دوغ بدون گاز ۱.۵ لیتری هراز", totalValue: 690000000 },
  //   { productName: "پنیر سفید ایرانی هراز", totalValue: 620000000 },
  //   { productName: "خامه صبحانه هراز", totalValue: 550000000 },
  //   { productName: "شیر پرچرب هراز", totalValue: 480000000 },
  //   { productName: "ماست موسیر هراز", totalValue: 410000000 },
  //   { productName: "دوغ نعنا هراز", totalValue: 350000000 },
  //   { productName: "کره حیوانی هراز", totalValue: 290000000 },
  // ];
  // ============ Load Top 10 Products ============
  useEffect(() => {
    if (!customer?.customerId) return;

    const loadTopProducts = async () => {
      try {
        const res = await getTopProducts(
          customer.customerId,
          selectedGroup
        );

        setTopProducts(res.data);
      } catch (err) {
        console.error("خطا در دریافت ۱۰ محصول پرخرید:", err);
        setTopProducts([]);
      }
    };

    loadTopProducts();
  }, [customer, selectedGroup]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
  }, []);

  // ============ Load KPI ============
  useEffect(() => {
    if (!customer || !customer.customerId) return;

    const loadKpi = async () => {
      try {
        const response = await getSalesKpi(customer.customerId, selectedGroup);
        setKpi(response.data);
      } catch (err) {
        console.error("خطا در دریافت KPI فروش:", err);
      }
    };

    loadKpi();
  }, [customer, selectedGroup]);

  // ============ Load Product Groups ============
  useEffect(() => {
    const loadGroups = async () => {
      const res = await getProductGroups();
      setGroups(res.data);
    };
    loadGroups();
  }, []);

  // ============ Load Not Bought Products ============
  useEffect(() => {
    if (!customer?.customerId) return;

    const loadNotBought = async () => {
      try {
        const res = await getNotBoughtProducts(
          customer.customerId,
          selectedGroup
        );
        setNotBought(res.data);
      } catch (err) {
        console.error("خطا در دریافت محصولات خرید‌نشده:", err);
      }
    };

    loadNotBought();
  }, [customer, selectedGroup]);

  // ============ Load Pie Chart Data ============
  useEffect(() => {
    const loadPieData = async () => {
      if (!customer?.customerId) return;
      const res = await getSalesByGroup(customer.customerId);
      setPieData(res.data);
    };

    loadPieData();
  }, [customer]);

  if (!kpi) {
    return (
      <DashboardLayout>
        <div className="text-center text-blue-600 py-10">
          در حال بارگذاری گزارش خرید...
        </div>
      </DashboardLayout>
    );
  }

  const isGrowth = kpi?.growthPercent >= 0;

  return (
    <DashboardLayout>
      <div className="py-3 flex flex-col gap-5" dir="rtl">
        {/* ================= Header ================= */}
        <div className="w-full flex justify-between items-center">
          <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
            گزارش خرید
          </h1>

          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
          >
            بازگشت
          </button>
        </div>

        {/* ================= KPI BOXES ================= */}
        <div className="bg-white rounded-2xl shadow p-5 mb-5">
          {/* ردیف اول — دسکتاپ  موبایل  KPIs */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1.5fr] gap-4 mb-6">
            {/* گروه محصول */}
            <div className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-1  w-full flex flex-col order-1">
              <label className="text-[10px] sm:text-sm font-medium text-gray-700 mb-1 block">
                گروه محصول
              </label>

              <select
                className="border border-blue-300/40 p-1.5 sm:p-2 rounded-md 
                    bg-[#EDF4FF]/60 backdrop-blur-md  
                    w-full sm:w-full md:w-1/2 lg:w-full xl:w-full md:w-1/2 text-[10px] sm:text-xs h-8 sm:h-10"
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
              >
                {groups.map((gp) => (
                  <option
                    key={gp.id}
                    value={gp.name === "همه" ? "all" : gp.name}
                  >
                    {gp.name}
                  </option>
                ))}
              </select>
            </div>

            {/* فروش ماه جاری */}
            <div className="col-span-1 order-2">
              <CardLargeWide
                title="خالص ریال خرید ماه جاری"
                value={kpi.currentMonthSales}
              />
            </div>

            {/* فروش ماه قبل */}
            <div className="col-span-1 order-3">
              <CardLargeWide
                title="خالص ریال خرید ماه قبل"
                value={kpi.lastMonthSales}
              />
            </div>

            {/* رشد — دسکتاپ */}
            <div className=" lg:block col-span-1 order-4">
              <GrowthCard growth={kpi.growthPercent} isGrowth={isGrowth} />
            </div>
          </div>

          {/* ================= ردیف دوم ================= */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {/* سطر 1 موبایل */}
            <div className="col-span-1 order-1 hidden">
              <GrowthCard growth={kpi.growthPercent} isGrowth={isGrowth} />
            </div>

            <div className="col-span-1 order-2 lg:order-none">
              <Card title="وزن خرید ماه جاری" value={kpi.currentMonthWeight} />
            </div>

            {/* سطر 2 موبایل */}
            <div className="col-span-1 order-3 lg:order-none">
              <Card title="وزن خرید ماه قبل" value={kpi.lastMonthWeight} />
            </div>

            <div className="col-span-1 order-4 lg:order-none">
              <Card title="وزن خرید سال قبل" value={kpi.lastYearWeight} />
            </div>

            {/* سطر 3 موبایل */}
            <div className="col-span-1 order-5 lg:order-none">
              <Card
                title="تعداد فاکتور ماه جاری"
                value={kpi.invoicesNumCurrentMonth}
              />
            </div>

            <div className="col-span-1 order-6 lg:order-none">
              <Card
                title="تعداد فاکتور ماه قبل"
                value={kpi.invoicesNumLastMonth}
              />
            </div>
          </div>
        </div>


        {/* ================= TABLES + PIECHART + Top 10 Products================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">

          {/* ================= Not Bought Products ================= */}
          <div className="md:col-span-1 lg:col-span-4 bg-white rounded-xl shadow p-4 h-[330px] flex flex-col">

            <h2 className="text-right font-bold text-purple-600 mb-3 text-sm">
              محصولاتی که در ماه جاری خرید نشده‌اند
            </h2>

            <div className="overflow-y-auto overflow-x-auto flex-1">
              <table className="w-full text-right text-xs">

                <thead className="sticky top-0 bg-gray-100 z-10">
                  <tr className="text-gray-600">
                    <th className="p-2">
                      نام محصول
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {notBought.length > 0 ? (
                    notBought.map((p, i) => (
                      <tr
                        key={i}
                        className="border-b hover:bg-blue-50 transition"
                      >
                        <td className="p-2 text-gray-700">
                          {p.productName}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-6 text-center text-gray-400">
                        داده‌ای برای نمایش وجود ندارد
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>

          </div>


          {/* ================= Top 10 Products ================= */}
          <div className="md:col-span-1 lg:col-span-4 bg-white rounded-xl shadow p-4 h-[330px] flex flex-col">

            <div className="flex items-center justify-between mb-3">
              <h2 className="text-right font-bold text-purple-600 text-sm">
                ۱۰ محصول پرخرید ماه گذشته
              </h2>

              <span className="text-[10px] text-gray-400">
                ارزش ریالی
              </span>
            </div>

            <div className="overflow-y-auto overflow-x-auto flex-1 [scrollbar-gutter:stable] pl-2">

              <table className="w-full text-right text-xs">

                <thead className="sticky top-0 bg-gray-100 z-10">
                  <tr className="text-gray-600">

                    <th className="p-2 w-10 text-center">
                      رتبه
                    </th>

                    <th className="p-2">
                      محصول
                    </th>

                    <th className="p-2 pl-4 text-left">
                      ارزش خرید
                    </th>

                  </tr>
                </thead>

                <tbody>
                  {topProducts.length > 0 ? (
                    topProducts.map((product, index) => (
                      <tr
                        key={product.productID || index}
                        className="border-b hover:bg-blue-50 transition"
                      >
                        <td className="p-2 text-center font-bold text-blue-700">
                          {(index + 1).toLocaleString("fa-IR")}
                        </td>

                        <td className="p-2 text-gray-700">
                          {product.productName}
                        </td>

                        <td className="p-2 pl-4 text-left font-semibold text-purple-700 whitespace-nowrap">
                          {product.totalValue?.toLocaleString("fa-IR")}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        className="p-6 text-center text-gray-400"
                      >
                        داده‌ای برای نمایش وجود ندارد
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>

            </div>

          </div>


          {/* ================= Pie Chart ================= */}
          <div className="md:col-span-2 lg:col-span-4 bg-white rounded-xl shadow p-3 h-[330px] flex flex-col">

            <h2 className="text-right font-bold text-purple-600 mb-3 text-sm">
              تفکیک خرید گروه محصولی
            </h2>

            {pieData.length > 0 ? (

              <div className="flex justify-center items-center flex-1 min-h-0 overflow-hidden">

                <PieChartComponent data={pieData} />

              </div>

            ) : (

              <div className="flex justify-center items-center flex-1 text-gray-400 text-xs">

                داده‌ای برای نمایش وجود ندارد

              </div>

            )}

          </div>

        </div>
      </div>
    </DashboardLayout>
  );
};

/* ================= Cards ================= */

const Card = ({ title, value }) => (
  <div className="backdrop-blur-lg bg-blue-100/30 border border-white/40 shadow-xl rounded-xl p-4">
    <div className="flex items-center justify-between">
      <span className="text-[10px] sm:text-xs font-medium">{title}</span>
      <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-purple-100 flex items-center justify-center shadow-sm">
        <FaChartBar className="text-purple-600 text-[12px] sm:text-sm" />
      </div>
    </div>
    <div className="text-sm sm:text-base font-bold text-purple-700">
      {value?.toLocaleString("fa-IR")}
    </div>
  </div>
);

const CardLargeWide = ({ title, value }) => (
  <div className="backdrop-blur-lg bg-blue-100/30 border border-white/40 shadow-xl rounded-xl p-4">
    <div className="flex items-center justify-between">
      <span className="text-[10px] sm:text-sm">{title}</span>
      <div className="w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-purple-100 flex items-center justify-center shadow-sm">
        <FaChartBar className="text-purple-600 text-[14px] sm:text-lg" />
      </div>
    </div>
    <div className="text-sm sm:text-lg font-bold text-purple-700">
      {value?.toLocaleString("fa-IR")}
    </div>
  </div>
);

const GrowthCard = ({ growth, isGrowth }) => (
  <div className="backdrop-blur-lg bg-blue-100/30 border border-white/40 shadow-xl rounded-xl p-4">
    <div className="flex items-center justify-between">
      <span className="text-[10px] sm:text-sm">رشد(افت) نسبت به ماه قبل تا روز جاری</span>
      <div className="w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-purple-100 flex items-center justify-center shadow-sm">
        {isGrowth ? (
          <FaArrowUp className="text-green-700 text-[14px] sm:text-lg" />
        ) : (
          <FaArrowDown className="text-red-700 text-[14px] sm:text-lg" />
        )}
      </div>
    </div>

    <div
      className={`text-sm sm:text-lg font-bold ${isGrowth ? "text-green-700" : "text-red-700"
        }`}
    >
      {growth.toFixed(1)}%
    </div>
  </div>
);

export default SalesInfo;
